module.exports = __webpack_public_path__ + "static/img/about_modle_2.9041a281.jpg";